module.exports = __webpack_public_path__ + "static/media/MoisesL.ce02f6a7.jpg";